export const round = (value: any, decimal: number = 0) => {
  if (typeof value === "number") {
    return Math.round(value * 10 ** decimal) / 10 ** decimal;
  } else {
    return value ? Math.round(Number.parseFloat(value)) : value;
  }
};

export const getArrow = (trend?: string) => {
  switch (trend) {
    case "UP":
      return "↗";
    case "DOWN":
      return "↘";
    case "STRAIGHT":
    default:
      return "→";
  }
};